import type { Store } from 'redux';

/**
 * This should only be used by {@link getStore} and {@link setStore}.
  */
export const storeManager: { store?: Store } = {
  store: undefined
};